"use strict";
if (!String.format) {
    String.format = function () {
        console.warn('String.format is an unsafe extension to String. Please use Alkami.Utils.StringHelper.format instead.');
        return Alkami.Utils.StringHelper.format.apply(null, arguments);
    };
}
if (!window.hasOwnProperty('POBoxRegexPattern')) {
    Object.defineProperty(window, 'POBoxRegexPattern', {
        get() {
            console.warn('POBoxRegexPattern is deprecated. Please use Alkami.Patterns.POBox instead.');
            return Alkami.Patterns.POBox;
        }
    });
}
class HashTable {
    constructor(obj) {
        this.length = 0;
        this.items = {};
        console.warn('HashTable is deprecated. Please use Javascript Object API instead.');
        for (const p in obj) {
            if (obj.hasOwnProperty(p)) {
                this.items[p] = obj[p];
                this.length++;
            }
        }
    }
    clear() {
        this.items = {};
        this.length = 0;
    }
    each(fn) {
        Object.keys(this.items).forEach((k) => fn(k, this.items[k]));
    }
    hasItem(key) {
        return this.items.hasOwnProperty(key);
    }
    keys() {
        return Object.keys(this.items);
    }
    values() {
        return Object.keys(this.items).map((key) => this.items[key]);
    }
    setItem(key, value) {
        let previous;
        if (this.hasItem(key)) {
            previous = this.items[key];
        }
        else {
            this.length++;
        }
        this.items[key] = value;
        return previous;
    }
    removeItem(key) {
        if (this.hasItem(key)) {
            const previous = this.items[key];
            this.length--;
            delete this.items[key];
            return previous;
        }
        return undefined;
    }
}


